import { render, staticRenderFns } from "./LiteSidebarDesignList.vue?vue&type=template&id=659b6264&scoped=true&"
import script from "./LiteSidebarDesignList.vue?vue&type=script&lang=js&"
export * from "./LiteSidebarDesignList.vue?vue&type=script&lang=js&"
import style0 from "./LiteSidebarDesignList.vue?vue&type=style&index=0&id=659b6264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659b6264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('659b6264')) {
      api.createRecord('659b6264', component.options)
    } else {
      api.reload('659b6264', component.options)
    }
    module.hot.accept("./LiteSidebarDesignList.vue?vue&type=template&id=659b6264&scoped=true&", function () {
      api.rerender('659b6264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/Lite/LiteSidebarDesignList.vue"
export default component.exports